import { render, staticRenderFns } from "./CustomerProjectBriefList.vue?vue&type=template&id=3720bd31&scoped=true&"
import script from "./CustomerProjectBriefList.vue?vue&type=script&lang=js&"
export * from "./CustomerProjectBriefList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProjectBriefList.vue?vue&type=style&index=0&id=3720bd31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3720bd31",
  null
  
)

export default component.exports